<template>
  <div :class="isWorkTime ? 'work' : 'break'">
    <div>
      <button @click="toggleSettings" class="setting-btn btn">
        <img :src="require('@/assets/icons/setting.svg')" alt="設定" />
      </button>

      <!-- 設定画面 -->
      <transition name="slide-down">
        <div v-if="showSettings" class="settings-panel">
        <h2>設定</h2>
        <table>
          <tr><label>
            <th>集中時間</th>
            <td><input type="number" v-model.number="inputWorkMinutes" min="1" max="120" />分</td>
          </label></tr>
          <tr><label>
            <th>休憩時間</th>
            <td><input type="number" v-model.number="inputBreakMinutes" min="1" max="120" />分</td>
          </label></tr>
          <tr><label>
            <th>長時間休憩時間</th>
            <td><input type="number" v-model.number="inputLongBreakMinutes" min="1" max="120" />分</td>
          </label></tr>
          <tr><label>
            <th>長時間休憩頻度</th>
            <td><input type="number" v-model.number="inputLongBreakFreq" min="1" max="100"/>回</td>
          </label></tr>
          <tr><label>
            <th>集中の自動スタート</th>
            <td>
              <span class="toggle-button-2">
                <input type="checkbox" v-model="autoOnStart" />
              </span>
            </td>
          </label></tr>
          <tr><label>
            <th>休憩の自動スタート</th>
            <td>
              <span class="toggle-button-2">
                <input type="checkbox" v-model="autoOffStart" />
              </span>
            </td>
          </label></tr>
          <tr><label>
            <th>通知音</th>
            <td>
              <span class="toggle-button-2">
                <input type="checkbox" v-model="playNotification" />
              </span>
            </td>
          </label></tr>
          <tr><label>
            <th>デジタル表示</th>
            <td>
              <span class="toggle-button-2">
                <input type="checkbox" v-model="displayDigital" />
              </span>
            </td>
          </label></tr>
          <tr><label>
            <th>アナログ表示</th>
            <td>
              <span class="toggle-button-2">
                <input type="checkbox" v-model="displayAnalog" />
              </span>
            </td>
          </label></tr>
        </table>
        <div class="sns-nav">
        <a href="https://twitter.com/zutsu_tsu?ref_src=twsrc%5Etfw" class="sns-logo-button" data-show-count="false">
          <img :src="require('@/assets/icons/x-logo.svg')" alt="X(旧Twitter)" class="sns-logo" />
        </a>
        <a href="https://marshmallow-qa.com/sbh3a23jbx0zuji?t=SncSdi&utm_medium=url_text&utm_source=promotion" class="sns-logo-button" data-show-count="false">
          <img :src="require('@/assets/icons/mail-logo.svg')" alt="マシュマロ" class="sns-logo" />
        </a>
        </div>
        <button @click="applySettings" class="close-btn btn">
          <img :src="require('@/assets/icons/close.svg')" alt="閉じる" />
        </button>
        </div>
      </transition>
    </div>

    <h2>{{ setCount }}ポモドーロ</h2>
    <h1 :class="displayDigital ? 'display' : 'hidden'">{{ formattedTime }}</h1>

    <MySandglass ref="MySandglass" :class="displayAnalog ? 'display' : 'hidden'" :timeRemain="seconds" :timeMax="isWorkTime ? workDuration : breakDuration" :running="isRunning" :isWorkTime="isWorkTime" />
    
    <!-- 操作ボタン -->
    <div>
      <button v-if="!isRunning" @click="startNextSession" class="play-btn btn">
        <img :src="require('@/assets/icons/play.svg')" alt="スタート" />
      </button>
      <button v-if="isRunning" @click="stopTimer" class="pause-btn btn">
        <img :src="require('@/assets/icons/pause.svg')" alt="ストップ" />
      </button>
      <button @click="resetTimer" class="reset-btn btn">
        <img :src="require('@/assets/icons/reset.svg')" alt="リセット" />
      </button>
    </div>
  </div>
</template>

<script>
import MySandglass from './MySandglass.vue';
import { nextTick } from 'vue';

export default {
  components: { MySandglass },
  name: 'MyPomodoro',
  data() {
    return {
      setCount: 1,  // セット数カウント用
      showSettings: false,
      inputWorkMinutes: 25,
      inputBreakMinutes: 5,
      inputLongBreakMinutes: 15,
      inputLongBreakFreq: 4,
      playNotification: true,
      autoOnStart: false,
      autoOffStart: false,
      displayDigital: true,
      displayAnalog: true,
      workDuration: 1500,
      breakDuration: 300,
      seconds: 1500,
      isWorkTime: true,
      isRunning: false,
      timerId: null,
      audio: null,
      wakeLock: null
    };
  },
  computed: {
    formattedTime() {
      const min = String(Math.floor(this.seconds / 60)).padStart(2, '0');
      const sec = String(this.seconds % 60).padStart(2, '0');
      return `${min}:${sec}`;
    }
  },
  methods: {
    async requestWakeLock() {
      try {
        if ('wakeLock' in navigator) {
          this.wakeLock = await navigator.wakeLock.request('screen');
          console.log('✅ Wake Lock is active');
          this.wakeLock.addEventListener('release', () => {
            console.log('🔓 Wake Lock released');
          });
        }
      } catch (err) {
        console.error('❌ Wake Lock error:', err);
      }
    },
    async releaseWakeLock() {
      if (this.wakeLock) {
        await this.wakeLock.release();
        this.wakeLock = null;
        console.log('👋 Wake Lock manually released');
      }
    },
    toggleSettings() {
      this.showSettings = !this.showSettings;
    },
    applySettings() {
      if ((this.inputWorkMinutes < 1 || this.inputWorkMinutes > 120) || 
        (this.inputLongBreakFreq < 1 || this.inputLongBreakFreq > 100) ||
        (this.inputBreakMinutes < 1 || this.inputBreakMinutes > 120) ||
        (this.inputLongBreakMinutes < 1 || this.inputLongBreakMinutes > 120)
        ) {
        alert('設定値が不正です');
        return;
      }
      this.workDuration = this.inputWorkMinutes * 60;
      this.breakDuration = this.setCount%this.inputLongBreakFreq != 0 ? this.inputBreakMinutes * 60 : this.inputLongBreakMinutes * 60;
      this.seconds = this.isWorkTime ? this.workDuration : this.breakDuration;
      this.showSettings = false;  // 設定完了で画面を閉じる
    },
    startTimer() {
      this.requestWakeLock(); // 👈 タイマー開始時に Wake Lock を要求
      this.audio = new Audio(require('@/assets/sound/alarm.mp3'));
      const maxTime = this.isWorkTime ? this.workDuration : this.breakDuration;
      // アニメーション準備のための遅延
      var waitTime = 0;
      if (this.seconds == maxTime) {
        this.$refs.MySandglass.turnSandglass();
        waitTime = 550;
      }
      setTimeout(() => {
        this.isRunning = true;
        this.$refs.MySandglass.updateSand();
        this.timerId = setInterval(() => {
          if (this.seconds > 0) {
            this.seconds--;
          } else {
            this.endSession();
          }
          this.$refs.MySandglass.updateSand();
        }, 1000);
      }, waitTime);
    },
    stopTimer() {
      clearInterval(this.timerId);
      this.isRunning = false;
      this.releaseWakeLock(); // 👈 タイマー停止時に Wake Lock を解放
    },
    resetTimer() {
      this.stopTimer();
      this.isWorkTime = true;
      this.seconds = this.workDuration;
      this.setCount = 1;
      nextTick(() => {
        this.$refs.MySandglass.reset();
      });
    },
    endSession() {
      this.stopTimer();
      if (this.audio && this.playNotification) {
        if ("vibrate" in navigator) {
          navigator.vibrate(100); // 100ミリ秒振動
        }
        this.audio.play().catch((e) => {
          console.warn('通知音の再生がブロックされました。:', e);
        });
      }
      this.isWorkTime = !this.isWorkTime;
      this.breakDuration = this.setCount%this.inputLongBreakFreq != 0 ? this.inputBreakMinutes * 60 : this.inputLongBreakMinutes * 60;
      this.seconds = this.isWorkTime ? this.workDuration : this.breakDuration;
      if (this.isWorkTime) {
        this.setCount++;  // 集中タイマーが終わったらセット数をカウントアップ
      }
      if ((this.isWorkTime && this.autoOnStart) || (!this.isWorkTime && this.autoOffStart)){
        nextTick(() => {
          this.startNextSession();
        });
      }
    },
    startNextSession() {
      this.startTimer();
    },
  },
  beforeDestroy() {
    clearInterval(this.timerId);
    this.releaseWakeLock();
  }
};
</script>

<style scoped>
h1, h2 {
  margin-top: 15px;
  margin-bottom: 0;
}
h1{
  font-size: 50px;
}
h2 {
  font-size: 20px;
}
.btn {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  width: 50px;
  height: 50px;
}
.btn img {
  margin: 0;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.setting-btn {
  position: fixed;
  top: 3vh;
  right: 3vw;
  z-index: 999;
}
.close-btn {
  width: 43px;
  height: 43px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  background-color: #fffafa;
  border : 1.5px solid #756AA6;
  border-radius: 50%;
}
.close-btn img {
  width: 40px;
  height: 40px;
}
.play-btn,
.pause-btn {
  margin-right: 50px;
}
.setting-btn img:hover ,
.reset-btn img:hover{
  transform: rotate(20deg);
}

.sns-nav {
  display: flex;
  margin: 30px auto;
  width: 100%;
  justify-content: space-around;
}
.sns-logo-button {
  display: inline-block;
  padding: 5px;

}
.sns-logo {
  height: 35px;
  width: 35px;
}

.settings-panel {
  margin: auto;
  box-sizing: border-box;
  position: fixed;
  top: 4vh;
  left: 5vw;
  right: 5vw;
  border-radius: 10px;
  background: #fffafa;
  padding: 15px;
  width: 90vw;
  max-width: 500px;
  height:580px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  z-index: 1000;
}

.work {
  color: #756AA6;
  text-align: center;
  padding: 20px 30px 150px 30px;
  min-height: 100vh;
  background: linear-gradient(-45deg, #FFE4E1, #FFD1D1, #FFF0F0, #FCE4EC, #FFFFFF);
  background-size: 400% 400%;
  animation: gradientMove 10s ease infinite;
}
.break {
  color: #756AA6;
  text-align: center;
  padding: 20px 30px 150px 30px;
  min-height: 100vh;
  background: linear-gradient(-45deg, #E0F7FA, #D0F0FF, #E0FFFF, #CCF2FF, #FFFFFF);
  background-size: 400% 400%;
  animation: gradientMove 10s ease infinite;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

input {
  width: 60px;
  text-align: right;
  margin: 0 10px;
}
table {
  width: 100%;
}
label {
  display: inline-block;
  width: 100%;
}
th, td {
  display: inline-block;
  box-sizing: border-box;
  height: 40px;
  font-weight: normal;
}
th {
  text-align: left;
  font-size: 16px;
  width: 65%;
}
td {
  font-size: 14px;
  width: 35%;
}
input,
textarea,
select {
  font-size: 16px;
  border: 1px solid #756AA6;
  border-radius: 15px;
  padding: 2px 10px;
}
input[type="number"] {
  width: 40px;
}
.display {
  display: block;
}
.hidden {
  display: none;
}

.toggle-button-2 {
  display: inline-block;
  position: relative;
  width: 45px;
  height: 24px;  /* 少し大きくする */
  vertical-align: middle;
  border-radius: 20px;
  border: 1.5px solid #999999;
  box-sizing: content-box;
  cursor: pointer;
  transition: border-color .2s;
}
.toggle-button-2:has(:checked) {
    border-color: #E57373;
}
.toggle-button-2::after {
    position: absolute;
    top: 50%;
    left: 2px;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #999999;
    content: '';
    transition: left .2s;
}
.toggle-button-2:has(:checked)::after {
    left: 25px;
    background-color: #E57373;
}
.toggle-button-2 input {
    display: none;
}
</style>
